import { Component, OnInit } from '@angular/core';
import * as M from '../../../assets/js/materialize.js';
import { AntipigmentoService } from 'src/app/services/antipigmento.service';
import { SecaService } from 'src/app/services/seca.service.js';

@Component({
  selector: 'app-antipigmento',
  templateUrl: './antipigmento.component.html',
  styleUrls: ['./antipigmento.component.css']
})
export class AntipigmentoComponent implements OnInit {
  constructor( public antipigmentoService: AntipigmentoService,public secaservice:SecaService ) { }

  ngOnInit() {
    const instance = M.Tabs.init( document.querySelectorAll('.tabs'), {} );
  }

}
